import { Spinner } from "@/components/ui/spinner"
import { cn } from "@/lib/utils"

function SectionLoading({ className }: React.ComponentProps<"div">) {
  return (
    <div className="flex items-center justify-center p-10">
      <Spinner
        role="status"
        aria-label="Loading"
        className={cn("size-6 animate-spin", className)}
      />
    </div>
  )
}

export { SectionLoading }
